import React from "react";
import { BookOpen } from "lucide-react";
import Navigation from "../Thesis_work/Navigation";
import SEO from "../../common/SEO";


const AssuranceHomePage = () => {
  return (
    <div>
      <SEO 
        title="Best Thesis Writing Services in Bhopal | PhD & MTech Thesis Writing"
        description="Assurance Education Group provides the best thesis writing services in Bhopal, MTech thesis writing, PhD thesis writing help, paper writing, plagiarism check, SCI & Scopus paper publication."
        keywords={[
          "best thesis writing services in bhopal",
          "Mtech Thesis Writing",
          "PhD Thesis writing service and help",
          "Paper Writing Bhopal",
          "Plagiarism Check Bhopal",
          "Review paper writing bhopal",
          "Research paper writing and publication",
          "SCI paper writing bhopal",
          "Scopus paper writing bhopal"
        ]}
        canonicalPath="/thesis-home"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Thesis Writing Services", path: "/thesis-home" }
        ]}
        schemaData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Thesis Writing Services in Bhopal",
          "serviceType": "Thesis writing, paper writing and research paper publication",
          "provider": { "@id": "https://aegresearch.in/#organization" },
          "areaServed": { "@type": "City", "name": "Bhopal" },
          "description": "Best thesis writing services in Bhopal by Assurance Education Group - thesis writing, paper writing, SCI research paper guidance, research paper publication, SCI paper publication and Scopus paper publication.",
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Thesis and Publication Services",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Thesis Writing" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Paper Writing" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SCI Research Paper Guidance" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Research Paper Publication" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SCI Paper Publication" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Scopus Paper Publication" } }
            ]
          }
        }}
      />

      {/* Navbar fixed top pe rahega */}
      <Navigation />
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSeHeauxibJQo0Vk_jJP2MI2U_Vz2oAK8uuUBZqkihljTOBf1Q/viewform?usp=send_form"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed z-50 bottom-3 right-3 inline-flex items-center gap-2 
                  rounded-full bg-blue-600 px-6 py-3 text-sm font-semibold text-white 
                  shadow-2xl shadow-blue-500/30
                  transition-all duration-300
                  hover:bg-blue-700 hover:scale-110
                  animate-bounce-slow"
      >
        <BookOpen className="w-4 h-4 animate-pulse" />
        Registration
      </a>

      {/* Sections */}
      {/* <main className=" ">
       <Element 
  name="home" 
  className="h-screen w-full"
>
  <HomeCrousal />
</Element>

        <Element name="services" className="  min-h-screen w-screen flex items-center justify-center">
       <ResearchHubPage/>
        </Element>

        <Element name="flowchart" className="min-h-screen w-screen flex items-center justify-center overflow-x-hidden">
          <FlowChart />
        </Element>

        <Element name="contact" className="min-h-screen w-full flex items-center justify-center">
         <ContactForm/>
        </Element>
      </main> */}
    </div>
  );
};

export default AssuranceHomePage;
